// src/index.js — PresentPlus v7 Ultra Root Patch

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import "./styles/theme.css";
import { AuthProvider } from "./contexts/AuthContext";


import { AttendanceProvider } from "./contexts/AttendanceContext";
import { ThemeProvider } from "./contexts/ThemeContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
      <AuthProvider>
        <AttendanceProvider>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </AttendanceProvider>
      </AuthProvider>
  </React.StrictMode>
);
